/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Metrokennung } from '../models';
/**
 * MetrokennungService - axios parameter creator
 * @export
 */
export const MetrokennungServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Metrokennungen
         * @summary Metrokennungen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrokennungen: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrokennungen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetrokennungService - functional programming interface
 * @export
 */
export const MetrokennungServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetrokennungServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Metrokennungen
         * @summary Metrokennungen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetrokennungen(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Metrokennung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetrokennungen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetrokennungService - factory interface
 * @export
 */
export const MetrokennungServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetrokennungServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Metrokennungen
         * @summary Metrokennungen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrokennungen(options?: any): AxiosPromise<Array<Metrokennung>> {
            return localVarFp.getMetrokennungen(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetrokennungService - interface
 * @export
 * @interface MetrokennungService
 */
export interface MetrokennungServiceInterface {
    /**
     * Liefert eine Liste von Metrokennungen
     * @summary Metrokennungen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetrokennungServiceInterface
     */
    getMetrokennungen(options?: any): AxiosPromise<Array<Metrokennung>>;

}

/**
 * MetrokennungService - object-oriented interface
 * @export
 * @class MetrokennungService
 * @extends {BaseAPI}
 */
export class MetrokennungService extends BaseAPI implements MetrokennungServiceInterface {
    /**
     * Liefert eine Liste von Metrokennungen
     * @summary Metrokennungen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetrokennungService
     */
    public getMetrokennungen(options?: any) {
        return MetrokennungServiceFp(this.configuration).getMetrokennungen(options).then((request) => request(this.axios, this.basePath));
    }
}
